import { CommonModule, CurrencyPipe, NgOptimizedImage } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LottieModule } from 'ngx-lottie';
import { playerFactory } from './lottie-player.factory';
import { ButtonComponent } from 'src/app/components/shared/button/button.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material/material';
import { PrimeMaterialModule } from '../ng-prime/prime-material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClientModule } from '@angular/common/http';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BeatsComponent } from 'src/app/components/shared/beats/beats.component';
import { FilterSectionComponent } from 'src/app/components/shared/filter-section/filter-section.component';
import { CommonBeatsDialogModule } from '../common-beats-dialog/common-beats-dialog.module';
import { GetPriceValuePipe } from 'src/app/pipes/get-price-value/get-price-value.pipe';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MusicPlayerComponent } from 'src/app/components/shared/music-player/music-player.component';
import { EqualizerAnimationComponent } from 'src/app/components/shared/equalizer-animation/equalizer-animation.component';
import { BillingAddressesComponent } from 'src/app/components/shared/billing-addresses/billing-addresses.component';
import { AddBillingAddressFormComponent } from 'src/app/components/shared/billing-addresses/add-billing-address-form/add-billing-address-form.component';
import { AuthComponent } from 'src/app/components/auth/auth.component';
import { LoginSignupComponent } from 'src/app/components/shared/login-signup/login-signup.component';
import { ChangePasswordComponent } from 'src/app/components/shared/popups/change-password/change-password.component';
import { ForgotPasswordComponent } from 'src/app/components/auth/forgot-password/forgot-password.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { OtpPageComponent } from 'src/app/components/shared/popups/otp-page/otp-page.component';
import { SellerAgreementComponent } from 'src/app/components/shared/popups/seller-agreement/seller-agreement.component';
import { SellerConfirmationPopupComponent } from 'src/app/components/shared/popups/seller-confirmation-popup/seller-confirmation-popup.component';
import { ProducerJoinFormComponent } from 'src/app/components/shared/popups/producer-join-form/producer-join-form.component';
import { ProducerConfirmationPopupComponent } from 'src/app/components/auth/producer-confirmation-popup/producer-confirmation-popup.component';
import { ConfirmationComponent } from 'src/app/components/shared/popups/confirmation/confirmation.component';
import { InfoDialogComponent } from 'src/app/components/shared/popups/info-dialog/info-dialog.component';
import { NotifyPopupComponent } from 'src/app/components/shared/popups/notify/notify-popup.component';
import { EmptyDataMessageComponent } from 'src/app/components/shared/empty-data-message/empty-data-message.component';
import { GetFormControlPipe } from 'src/app/pipes/get-form-controls/get-form-control.pipe';
import { GetArrayPipe } from 'src/app/pipes/getArray/get-array.pipe';
import { LoadingSpinnerComponent } from 'src/app/components/shared/loading-spinner/loading-spinner.component';
import { UserService } from 'src/app/services/user-service/user.service';
import { UISafePipe } from 'src/app/pipes/Ui-safe/ui-safe.pipe';
import { GetLicenceTitlePipe } from 'src/app/pipes/get-lic-name/get-licence-title.pipe';
import { FavoriteService } from 'src/app/services/favorite/favorite.service';
import { GetFilterKeysNamePipe } from 'src/app/pipes/get-filter-keys-name/get-filter-keys-name.pipe';
import { NonLoginUserPopupComponent } from 'src/app/components/shared/popups/non-login-user-popup/non-login-user-popup.component';
import { CouponPopupComponent } from 'src/app/components/shared/popups/coupon-popup/coupon-popup.component';
import { CouponAppliedPopupComponent } from 'src/app/components/shared/popups/coupon-applied-popup/coupon-applied-popup.component';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { GetTooltipPlusValuePipe } from 'src/app/pipes/get-tooltip-plus-value/get-tooltip-plus-value.pipe';
import { GetLicDropDownValuePipe } from 'src/app/pipes/get-lic-dropdown-value/get-lic-dropdown.pipe';
import { UserOrderDetailsComponent } from 'src/app/components/shared/popups/user-order-details/user-order-details.component';
import { DateFormatterPipe } from 'src/app/pipes/date-format/date-formatter.pipe';
import { LineComponent } from 'src/app/components/shared/charts/line/line.component';
import { PieComponent } from 'src/app/components/shared/charts/pie/pie.component';
import { BarComponent } from 'src/app/components/shared/charts/bar/bar.component';
import { BillingAddressPopupComponent } from 'src/app/components/shared/popups/billing-address-popup/billing-address-popup.component';
import { GetSubscriptionTiresPipe } from 'src/app/pipes/get-subs-tires/get-subs-tires.pipe';
import { GetActivePlanDetails } from 'src/app/pipes/get-active-plan-name/get-active-plan-name.pipe';
import { GetSubsAnnualPlanDetails } from 'src/app/pipes/get-subs-annual-price/get-subs-annual-price.pipe';
import { CommonSectionComponent } from 'src/app/components/landing-page/common-section/common-section.component';
import { NegotiationPopsComponent } from 'src/app/components/shared/popups/negotiation-pops/negotiation-pops.component';
import { SubscriptionComponent } from 'src/app/components/producer-components/subscription/subscription.component';
import { CheckExclusiveLic } from 'src/app/pipes/check-exclusive/check-exclusive-exist.pipe';
import { ProfileImgWithNameLetterPipe } from 'src/app/pipes/profile-img-name-letter/profile-img-with-name-letter.pipe';
import { MsFilterSearchPipe } from 'src/app/pipes/ms-filter-search/ms-filter-search.pipe';
import { FilterDataPipe } from 'src/app/pipes/filter-data/filter-data.pipe';
import { ButtonToggleComponent } from 'src/app/components/shared/button-toggle/button-toggle.component';
import { StudioSocialLinkArrayPipe } from 'src/app/pipes/studio-social-link-array/studio-social-link-array.pipe';
import { NavbarChangeClassDirective } from 'src/app/directives/navbar-change-class.directive';
import { SideTabMobileChangeClassDirective } from 'src/app/directives/side-tab-mobile-change-class.directive';
import { AdVisibilityDirective } from 'src/app/directives/ad-visibility.directive';
import { CustomTabsComponent } from 'src/app/components/shared/custom-tabs/custom-tabs.component';
import { ReferComponent } from 'src/app/components/shared/popups/refer/refer.component';
import { GetElementDataPipe } from 'src/app/pipes/element-data/get-element-data-control.pipe';
import { SkeletonLoaderComponent } from 'src/app/components/shared/skeleton-loader/skeleton-loader.component';
import { FilterListSeprationPipe } from 'src/app/pipes/filter-list/filter-list-sepration.pipe';
import { FilterSearchSectionComponent } from 'src/app/components/shared/filter-search-section/filter-search-section.component';
import { FilterDataTablePipe } from 'src/app/pipes/filter-data-table/filter-data-table.pipe';
import { DataTableComponent } from 'src/app/components/shared/data-table/data-table.component';
import { DataTableMobileViewComponent } from 'src/app/components/shared/data-table-mobile-view/data-table-mobile-view.component';
import { TableComponent } from 'src/app/components/shared/table/table.component';
import { MobileVerifyComponent } from 'src/app/components/shared/mobile-verify/mobile-verify.component';
import { AadharVerifyComponent } from 'src/app/components/shared/aadhar-verify/aadhar-verify.component';
import { NumberSuffixPipePipe } from 'src/app/pipes/number-suffix/number-suffix-pipe.pipe';
import { BannerComponent } from 'src/app/components/shared/banner/banner.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { GetAgePipe } from 'src/app/pipes/get-age/get-age.pipe';
import { BpmArenaBeatsComponent } from 'src/app/components/shared/bpm-arena-beats/bpm-arena-beats.component';
import { CountdownTimerComponent } from 'src/app/components/shared/countdown-timer/countdown-timer.component';
import { SplitBeatListPipe } from 'src/app/pipes/split-beat-list/split-beat-list.pipe';
import { DiwaliSectionComponent } from 'src/app/components/landing-page/diwali-section/diwali-section.component';
import { PadNumberPipe } from 'src/app/pipes/pad-number/pad-number.pipe';
import { ScrollBackgroundDirective } from 'src/app/directives/scroll-background.directive';
import { DragScrollDirective } from 'src/app/directives/drag-scroll.directive';
import { DiwaliSaleBannerComponent } from 'src/app/components/shared/diwali-sale-banner/diwali-sale-banner.component';
import { DiscountFilterComponent } from 'src/app/components/shared/discount-filter/discount-filter.component';
import { SaleCountdownComponent } from 'src/app/components/shared/sale-countdown/sale-countdown.component';
import { DiwaliSaleCardComponent } from 'src/app/components/shared/diwali-sale-card/diwali-sale-card.component';
import { DiwaliHeroPanelComponent } from 'src/app/components/shared/diwali-hero-panel/diwali-hero-panel.component';
import { TopSellersComponent } from 'src/app/components/shared/top-sellers/top-sellers.component';
import { DiwaliSaleHeaderComponent } from 'src/app/components/shared/diwali-sale-header/diwali-sale-header.component';
import { DiwaliSaleStripComponent } from 'src/app/components/shared/diwali-sale-strip/diwali-sale-strip.component';
import { DiwaliSparklesComponent } from 'src/app/components/shared/diwali-sparkles/diwali-sparkles.component';
import { FireworksDirective } from 'src/app/directives/fireworks.directive';
import { TransparentNavbarDirective } from 'src/app/directives/transparent-navbar.directive';
import { HomeBpmArenaComponent } from 'src/app/components/landing-page/home-bpm-arena/home-bpm-arena.component';
import { ByteFormatPipe } from 'src/app/pipes/byte-format/byte-format.pipe';
import { CountWordPipe } from 'src/app/pipes/count-word/count-word.pipe';
import { InfoIconComponent } from 'src/app/components/shared/info-icon/info-icon.component';
import { WaveMusicComponent } from 'src/app/components/shared/wave-music/wave-music.component';
import { ElementKeyNamePipe } from 'src/app/pipes/element-key-name/element-key-name.pipe';
import { ProKitsListComponent } from 'src/app/components/pro-kits-list/pro-kits-list.component';
import { SubscriptionDetailsComponent } from 'src/app/components/shared/subscription-details/subscription-details.component';
import { OrderHelpSupportComponent } from 'src/app/components/shared/order-help-support/order-help-support.component';
import { FooterComponent } from 'src/app/components/layout/footer/footer.component';
import { SubsFilterPipe } from 'src/app/pipes/subs-filter/subs-filter.pipe';
import { OnboardingFlowComponent } from 'src/app/components/shared/popups/onboarding-flow/onboarding-flow.component';
import { OrderDetailsComponent } from 'src/app/components/order-details/order-details.component';
import { HelpComponent } from 'src/app/components/order/help/help.component';
import { RoyaltyFreeComponent } from 'src/app/components/sound-list/royalty-free/royalty-free.component';
import { WhatsappVerificationComponent } from 'src/app/components/shared/popups/whatsapp-verification/whatsapp-verification.component';
import { SearchModeToggleComponent } from 'src/app/components/shared/search-mode-toggle/search-mode-toggle.component';
import { MagicSearchComponent } from 'src/app/components/shared/magic-search/magic-search.component';
import { MagicSearchAudioModalComponent } from 'src/app/components/shared/magic-search/magic-search-audio-modal/magic-search-audio-modal.component';
import { LicenseValidationComponent } from 'src/app/components/license-validation/license-validation.component';
import { CampaignFundingComponent } from 'src/app/components/shared/campaign-funding/campaign-funding.component';
import { CommonDataTableComponent } from 'src/app/components/shared/common-data-table/common-data-table.component';
import { LearnTermsButtonComponent } from 'src/app/components/shared/learn-terms-button/learn-terms-button.component';
import { AcquisitionFunnelComponent } from 'src/app/components/shared/charts/acquisition-funnel/acquisition-funnel.component';
import { HeatmapComponent } from 'src/app/components/shared/charts/heatmap/heatmap.component';
import { DateRangePickerComponent } from 'src/app/components/shared/date-range-picker/date-range-picker.component';
import { VerificationGateComponent } from 'src/app/components/shared/popups/verification-gate/verification-gate.component';
import { JulyOfferPopupComponent } from 'src/app/components/shared/popups/july-offer-popup/july-offer-popup.component';
import { UpdateEmailPopupComponent } from 'src/app/components/shared/popups/update-email-popup/update-email-popup.component';
import { OfferPopupComponent } from 'src/app/components/shared/popups/offer-popup/offer-popup.component';
import { DiwaliProPopupComponent } from 'src/app/components/shared/popups/diwali-pro-popup/diwali-pro-popup.component';
import { DiwaliSaleIntroComponent } from 'src/app/components/shared/diwali-sale-intro/diwali-sale-intro.component';


const components = [
  SkeletonLoaderComponent,
  ButtonComponent,
  BeatsComponent,
  FilterSectionComponent,
  MusicPlayerComponent,
  EqualizerAnimationComponent,
  BillingAddressesComponent,
  AddBillingAddressFormComponent,
  AuthComponent,
  ForgotPasswordComponent,
  LoginSignupComponent,
  ChangePasswordComponent,
  OtpPageComponent,
  SellerAgreementComponent,
  SellerConfirmationPopupComponent,
  ProducerJoinFormComponent,
  ProducerConfirmationPopupComponent,
  ConfirmationComponent,
  InfoDialogComponent,
  NotifyPopupComponent,
  EmptyDataMessageComponent,
  LoadingSpinnerComponent,
  NonLoginUserPopupComponent,
  CouponPopupComponent,
  CouponAppliedPopupComponent,
  UserOrderDetailsComponent,
  LineComponent,
  PieComponent,
  BarComponent,
  BillingAddressPopupComponent,
  CommonSectionComponent,
  NegotiationPopsComponent,
  SubscriptionComponent,
  ButtonToggleComponent,
  NavbarChangeClassDirective,
  SideTabMobileChangeClassDirective,
  AdVisibilityDirective,
  CustomTabsComponent,
  ReferComponent,
  FilterSearchSectionComponent,
  DataTableComponent,
  DataTableMobileViewComponent,
  TableComponent,
  MobileVerifyComponent,
  AadharVerifyComponent,
  NumberSuffixPipePipe,
  BannerComponent,
  BpmArenaBeatsComponent,
  CountdownTimerComponent,
  BpmArenaBeatsComponent ,
  DiwaliSectionComponent,
  ScrollBackgroundDirective,
  TransparentNavbarDirective,
  DragScrollDirective,
  DiwaliSaleBannerComponent,
  DiwaliSaleStripComponent,
  DiwaliSparklesComponent,
  DiwaliSaleHeaderComponent,
  DiwaliHeroPanelComponent,
  TopSellersComponent,
  DiscountFilterComponent,
  SaleCountdownComponent,
  DiwaliSaleCardComponent,
  HomeBpmArenaComponent,
  MobileVerifyComponent,
  AadharVerifyComponent,
  InfoIconComponent,
  WaveMusicComponent,
  ProKitsListComponent,
  SubscriptionDetailsComponent,
  OrderHelpSupportComponent,
  FooterComponent,
  OnboardingFlowComponent,
  OrderDetailsComponent,
  HelpComponent,
  RoyaltyFreeComponent,
  WhatsappVerificationComponent,
  SearchModeToggleComponent,
  MagicSearchComponent,
  MagicSearchAudioModalComponent,
  LicenseValidationComponent,
  CampaignFundingComponent,
  UpdateEmailPopupComponent,
  CommonDataTableComponent,
  LearnTermsButtonComponent,
  AcquisitionFunnelComponent,
  HeatmapComponent,
  DateRangePickerComponent,
  VerificationGateComponent,
  JulyOfferPopupComponent,
  OfferPopupComponent,
  DiwaliProPopupComponent,
  DiwaliSaleIntroComponent
];

const pipes: any = [
  GetPriceValuePipe,
  GetFormControlPipe,
  GetLicenceTitlePipe,
  GetArrayPipe,
  UISafePipe,
  GetTooltipPlusValuePipe,
  GetLicDropDownValuePipe,
  DateFormatterPipe,
  GetActivePlanDetails,
  GetSubsAnnualPlanDetails,
  ProfileImgWithNameLetterPipe,
  FilterDataPipe,
  StudioSocialLinkArrayPipe,
  GetElementDataPipe,
  SplitBeatListPipe,
  PadNumberPipe,
  GetAgePipe,
  FilterDataTablePipe,
  ByteFormatPipe,
  CountWordPipe,
  ElementKeyNamePipe,
  SubsFilterPipe
]

const exportModules = [
  CommonBeatsDialogModule,
  MaterialModule,
  PrimeMaterialModule,
  LottieModule.forRoot({ player: playerFactory }),
  NgxSpinnerModule,
  HttpClientModule,
  FormsModule,
  ReactiveFormsModule,
  CarouselModule,
  NgOtpInputModule,
  NgOptimizedImage,
  SlickCarouselModule,
  InfiniteScrollModule,
  FireworksDirective
  
]

const providers = [
  CurrencyPipe ,
  GetLicenceTitlePipe,
  GetSubscriptionTiresPipe,
  GetActivePlanDetails,
  UserService,
  UISafePipe,
  FavoriteService,
  GetFilterKeysNamePipe,
  AnalyticsService,
  GetSubsAnnualPlanDetails,
  CheckExclusiveLic,
  ProfileImgWithNameLetterPipe,
  MsFilterSearchPipe,
  StudioSocialLinkArrayPipe,
  GetFormControlPipe,
  GetElementDataPipe,
  FilterListSeprationPipe,
  PadNumberPipe,
  GetAgePipe
];

@NgModule({
  declarations: [
    ...components,
    ...pipes
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    ...exportModules
  ],
  providers: [
    ...providers
  ],
  exports: [
    ...components,
    ...pipes,
    ...exportModules
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
